
import React from "react";
import { format } from "date-fns";
import CountryFlag from "@/components/country/CountryFlag";
import { isFileReference } from "@/utils/temporaryFileStorage";

interface DocumentListItemProps {
  document: any;
  index: number;
}

const DocumentListItem = ({ document, index }: DocumentListItemProps) => {
  // Display the file name if available
  const displayFileName = () => {
    if (!document.document_file) return "File uploaded";
    
    if (isFileReference(document.document_file)) {
      return document.document_file.name;
    } else if (document.document_file instanceof FileList && document.document_file.length > 0) {
      return document.document_file[0].name;
    } else if (document.document_file[0] && document.document_file[0].name) {
      return document.document_file[0].name;
    }
    return "File uploaded";
  };

  return (
    <li key={index} className="border p-3 rounded-md">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <CountryFlag countryCode={document.country_code} className="h-4 w-5" />
          <span className="font-medium">{document.document_type_id}</span>
          <span className="ml-2 text-xs px-2 py-0.5 rounded-full bg-blue-100 text-blue-800">
            {document.verification_purpose === 'primary' ? 'Primary ID' : 
             document.verification_purpose === 'expatriate' ? 'Expatriate Document' : 'Primary & Expatriate'}
          </span>
        </div>
        <span className="text-sm text-muted-foreground">Number: {document.document_number}</span>
      </div>
      <div className="mt-1 text-sm">
        {document.issue_date && (
          <span className="mr-4">
            Issued: {format(new Date(document.issue_date), 'PP')}
          </span>
        )}
        {document.expiry_date && (
          <span>
            Expires: {format(new Date(document.expiry_date), 'PP')}
          </span>
        )}
      </div>
      <div className="mt-2 text-xs text-muted-foreground">
        {document.document_file ? (
          <>File: {displayFileName()}</>
        ) : (
          <>File uploaded</>
        )}
      </div>
    </li>
  );
};

export default DocumentListItem;
